"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _brandColors = _interopRequireDefault(require("./brandColors"));

var _colors = require("@material-ui/core/colors");

var _polished = require("polished");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // https://www.lingoapp.com/space/86663/k/B2DE4BDF-3C89-44EF-9D84-E833AEB7FE02/DE9D9C25-B9C4-41BA-A7E4-C14B64C64EA8/?tkn=covARoOwR4m_6_U8zowW36a_qrMaql0bmEcfIpfVgwI


var _default = {
  primary: {
    main: _brandColors["default"].primaryPalette.violet
  },
  secondary: {
    main: _brandColors["default"].secondaryPalette.cobalt
  },
  matched: {
    main: _brandColors["default"].logomarkDotColors.gold
  },
  defaultAccentColor: {
    main: _brandColors["default"].secondaryPalette.cobalt
  },
  text: {
    primary: _brandColors["default"].grayScale.iron,
    secondary: _brandColors["default"].secondaryPalette.cobalt,
    gray1: _brandColors["default"].grayScale.gray1,
    gray2: _brandColors["default"].grayScale.gray2
  },
  background: {
    canvas: _brandColors["default"].grayScale.appCanvasColor,
    lightBlueCanvas: '#F9FBFD'
  },
  borderColor: _colors.grey[300],
  pickerHeaderColor: _colors.cyan[500],
  common: {
    black: _brandColors["default"].grayScale.iron
  },
  action: {
    infoHover: _brandColors["default"].grayScale.cloud,
    infoActive: (0, _polished.darken)(0.04, _brandColors["default"].grayScale.cloud)
  }
};
exports["default"] = _default;